import { Component, inject, OnInit } from '@angular/core';
import { PromocodeBannerFacade } from '@features/promocode-banner/facades/promocode-banner.facade';
import { PromocodeBanner } from '@features/promocode-banner/types';
import { Store } from '@ngrx/store';
import { CmsFacade } from '@rd/cms/facades/cms.facade';
import { getAuthRenderState } from '@rd/core/auth/store/selectors/auth.selectors';
import { AnalyticsService } from '@rd/core/services/analytics/analytics.service';
import { EnvService } from '@rd/core/services/env/env.service';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { CoreState } from '@rd/core/store/reducers';
import { Alert, AuthRenderState } from '@rd/types';
import { isNotNull } from '@rd/utils/isNotNull';
import { filter, map, Observable } from 'rxjs';

@Component({
  selector: 'rd-anz-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class AnzHomePageComponent implements OnInit {
  private cmsFacade = inject(CmsFacade);
  private envService = inject(EnvService);

  authRenderState: AuthRenderState;

  constructor(
    private analyticsService: AnalyticsService,
    private pageTitleService: PageTitleService,
    private store: Store<CoreState>,
    private promocodeBannerFacade: PromocodeBannerFacade,
  ) {}

  activeAlertBanners$: Observable<Alert[]> = this.cmsFacade
    .getContentByName({
      pageName: 'alerts-home',
      pageType: 'alerts',
      locale: 'en-au',
    })
    .pipe(
      filter(isNotNull),
      map((content) => {
        if (content.type === 'alerts') {
          return content.items.filter((item) =>
            this.envService.isProduction ? item.showAlert : item.previewAlert,
          );
        }
        return [];
      }),
    );

  globalSystemNoticeBannerMessage =
    '<strong>Important information</strong>: Gift Card redemptions and redemptions through the Rewards Store will be unavailable from 11:00pm Tuesday 25 Mar 2025 to 12:00am Wednesday 26 March AEDT due to scheduled maintenance.';

  homepageBannerFetchingError$: Observable<boolean> = this.cmsFacade
    .getContentErrorByName('homepage-banner')
    .pipe(map((error) => !!error));

  promocodeBanner$: Observable<PromocodeBanner> =
    this.promocodeBannerFacade.promocodeBanner$;

  ngOnInit(): void {
    this.analyticsService.track({
      routeName: this.analyticsService.sitemap.homepage,
    });
    this.pageTitleService.setPageTitle('home-page');
    this.store.select(getAuthRenderState).subscribe((authRenderState) => {
      this.authRenderState = authRenderState;
    });
  }
}
